import { Col, Row } from 'antd';
import { ResponsiveLine } from '@nivo/line';
import Helpers from '../../../../helpers';
import PropTypes from 'prop-types';

const LineChart = ({
  colors,
  data,
  tableData,
  format = (v) => v,
  itemWidth = 100,
  formatTooltip = (v) => v,
}) => {
  return (
    <Row>
      <Col span={24}>
        <ResponsiveLine
          colors={colors || ['#61cdbb', '#f47560']}
          data={data}
          margin={{ top: 50, right: 110, bottom: 120, left: 60 }}
          xScale={{ type: 'point' }}
          yScale={{
            type: 'linear',
            min: 'auto',
            max: 'auto',
            stacked: false,
            reverse: false,
          }}
          yFormat=' >-.2f'
          axisTop={null}
          axisRight={null}
          curve='monotoneX'
          enableGridX={false}
          enableSlices='x'
          sliceTooltip={({ slice }) => {
            const date = slice.points[0].data.x;
            return (
              <div
                style={{
                  background: 'white',
                  padding: '9px 12px',
                  border: '1px solid #ccc',
                }}
              >
                <div>{date}</div>
                {slice.points.map((point) => (
                  <div
                    key={point.id}
                    style={{
                      color: point.serieColor,
                      padding: '3px 0',
                    }}
                  >
                    <strong>{point.serieId}</strong>{' '}
                    {formatTooltip(point.data.y)}
                  </div>
                ))}
              </div>
            );
          }}
          axisBottom={{
            format: (tick) =>
              Helpers.hideTicksByCount(tableData, tick) ? tick : '',
            orient: 'bottom',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 90,
            legend: '',
            legendOffset: 36,
            legendPosition: 'middle',
            tickValues: 5,
          }}
          axisLeft={{
            orient: 'left',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legendOffset: -40,
            legendPosition: 'middle',
            format,
          }}
          lineWidth={2}
          pointSize={5}
          pointColor={{ theme: 'background' }}
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabelYOffset={-12}
          useMesh={true}
          height={500}
          legends={[
            {
              anchor: 'bottom',
              direction: 'row',
              justify: false,
              translateX: 0,
              translateY: 120,
              itemWidth: itemWidth,
              itemHeight: 50,
              itemsSpacing: 4,
              symbolSize: 20,
              symbolShape: 'circle',
              itemDirection: 'left-to-right',
              itemTextColor: '#777',
              effects: [
                {
                  on: 'hover',
                  style: {
                    itemBackground: 'rgba(0, 0, 0, .03)',
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
        />
      </Col>
    </Row>
  );
};

LineChart.propTypes = {
  colors: PropTypes.array,
  data: PropTypes.array.isRequired,
  tableData: PropTypes.array.isRequired,
};

export default LineChart;
